import React from 'react';
import { Helmet } from 'react-helmet-async';
import ParentLayout from '../Layout';
import Urls from '../Urls';
import { PayloadStates } from '@lore/utils';
import Loader from '../../../components/Loader';
import useNearbyProjectsEvents from '../../opportunities/Recommended/useNearbyProjectsEvents';
import Redirect from '../../../components/Redirect';
import useNearbyPartners from '../../people-people/Recommended/useNearbyPartners';
import useIntents from '../../../hooks/useIntents';

export default function Layout(props) {
  const users = useNearbyPartners();
  const opportunities = useNearbyProjectsEvents();

  const { isEducator, isPartner } = useIntents();

  if (
    users.state === PayloadStates.FETCHING ||
    opportunities.state === PayloadStates.FETCHING ||
    isEducator === undefined ||
    isPartner === undefined
  ) {
    return (
      <ParentLayout>
        <Helmet>
          <title>Setup - Redirect</title>
        </Helmet>
        <Loader />
      </ParentLayout>
    );
  }

  if (isEducator) {
    return (
      <ParentLayout>
        <Helmet>
          <title>Setup - Redirect</title>
        </Helmet>
        {users.meta.totalCount >= 12 ? (
          <Redirect
            to={Urls.REDIRECT_EDUCATOR_YES}
            replace={true}
          />
        ) : (
          <Redirect
            to={Urls.REDIRECT_EDUCATOR_NO}
            replace={true}
          />
        )}
      </ParentLayout>
    );
  }

  if (isPartner) {
    return (
      <ParentLayout>
        <Helmet>
          <title>Setup - Redirect</title>
        </Helmet>
        {opportunities.meta.totalCount >= 1 ? (
          <Redirect
            to={Urls.REDIRECT_PARTNER_YES}
            replace={true}
          />
        ) : (
          <Redirect
            to={Urls.REDIRECT_PARTNER_NO}
            replace={true}
          />
        )}
      </ParentLayout>
    );
  }

  return (
    <ParentLayout>
      <Helmet>
        <title>Setup - Redirect</title>
      </Helmet>
      <Redirect
        to={Urls.REDIRECT_UNKNOWN}
        replace={true}
      />
    </ParentLayout>
  );
};
